module.exports = __webpack_public_path__ + "img/no_entry.3dd8af1f.jpg";